
import { create } from "zustand";
import type { User, Role } from "@/lib/types";
import { api } from "@/lib/api";

interface AuthState {
  user: User | null;
  loading: boolean;
  initialized: boolean;
  load: () => Promise<void>;
  setUser: (user: User | null) => void;
  logout: () => Promise<void>;
  switchRole: (role: Role) => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  loading: false,
  initialized: false,
  load: async () => {
    set({ loading: true });
    const res = await api.auth.me();
    set({ user: res.ok ? res.data!.user : null, loading: false, initialized: true });
  },
  setUser: (user) => set({ user }),
  logout: async () => {
    await api.auth.logout();
    set({ user: null });
    if (typeof window !== "undefined") {
      window.location.hash = "#/";
    }
  },
  switchRole: async (role) => {
    const res = await api.auth.updateProfile({ activeRole: role });
    if (res.ok) set({ user: res.data!.user });
  },
}));
